package com.evoapps.evoshift.ui.user

import com.evoapps.evoshift.ui.util.WeatherForecastCard
import com.evoapps.evoshift.domain.explain.SpmhExplanations
import com.evoapps.evoshift.domain.explain.Side
import com.evoapps.evoshift.ui.finance.formatSpmhOrDash
import evoshift.composeapp.generated.resources.spmh
import com.evoapps.evoshift.ui.util.currentMonthNumber
import com.evoapps.evoshift.ui.util.inMonth
import androidx.compose.foundation.relocation.BringIntoViewRequester
import androidx.compose.foundation.relocation.bringIntoViewRequester
import androidx.compose.runtime.rememberCoroutineScope
import com.evoapps.evoshift.widgets.LocalOnColours
import kotlinx.coroutines.launch

import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.ui.theme.AnimatedAmountText
import androidx.compose.runtime.CompositionLocalProvider
import com.evoapps.evoshift.domain.explain.Calculation
import com.evoapps.evoshift.domain.explain.MonthExplanations
import com.evoapps.evoshift.ui.finance.ExplainableAmount
import com.evoapps.evoshift.ui.finance.LocalExplainNames

import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.domain.model.LabourBase
import com.evoapps.evoshift.ui.util.labourCardTitleRes
import com.evoapps.evoshift.ui.finance.MissingPayBanner
import com.evoapps.evoshift.viewmodels.MissingPayScope
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.ui.finance.formatPercent
import com.evoapps.evoshift.ui.finance.formatMoney
import com.evoapps.evoshift.ui.notifications.notificationsAction
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import evoshift.composeapp.generated.resources.financials_labor_costs
import evoshift.composeapp.generated.resources.revenue
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.adaptive.ResponsiveColumns
import com.evoapps.evoshift.ui.adaptive.DashboardColumns
import com.evoapps.evoshift.ui.adaptive.PostureAwareScaffold
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.adaptive.hoverLift
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.TrendingDown
import androidx.compose.material.icons.automirrored.filled.TrendingUp
import androidx.compose.material.icons.filled.ArrowDropDown
import androidx.compose.material.icons.filled.Notifications
import androidx.compose.material.icons.filled.Person
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.domain.usecase.AtWorkEntry
import com.evoapps.evoshift.viewmodels.Gate
import com.evoapps.evoshift.viewmodels.OwnerDashboardViewModel
import com.evoapps.evoshift.viewmodels.StaffingActions
import com.evoapps.evoshift.domain.staffing.StaffingVerdict
import com.evoapps.evoshift.ui.util.StaffingChip
import com.evoapps.evoshift.ui.util.staffingColor
import androidx.compose.material.icons.filled.Groups
import androidx.compose.material.icons.automirrored.filled.ArrowForward
import evoshift.composeapp.generated.resources.staffing_card_all_right
import evoshift.composeapp.generated.resources.staffing_card_open
import evoshift.composeapp.generated.resources.staffing_card_summary
import evoshift.composeapp.generated.resources.staffing_card_summary_both
import evoshift.composeapp.generated.resources.staffing_too_few_days
import evoshift.composeapp.generated.resources.staffing_too_many_days
import evoshift.composeapp.generated.resources.staffing_card_title
import com.evoapps.evoshift.viewmodels.shows
import com.evoapps.evoshift.widgets.LoadingSwap
import com.evoapps.evoshift.widgets.SkeletonCard
import com.evoapps.evoshift.widgets.RegularCard
import com.evoapps.evoshift.widgets.StandoutCard
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.GoldButton
import com.evoapps.evoshift.widgets.parseDecimal
import com.evoapps.evoshift.domain.model.DailyRecord
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.ui.util.dayShort
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import kotlinx.datetime.LocalDate
import evoshift.composeapp.generated.resources.daily_records_actual_net
import evoshift.composeapp.generated.resources.dashboard_fill_result_target
import evoshift.composeapp.generated.resources.dashboard_fill_result_title
import evoshift.composeapp.generated.resources.dashboard_fill_result_today
import evoshift.composeapp.generated.resources.dashboard_fill_result_yesterday
import evoshift.composeapp.generated.resources.number_invalid
import evoshift.composeapp.generated.resources.save
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.dashboard_no_active_data
import evoshift.composeapp.generated.resources.dashboard_notifications
import evoshift.composeapp.generated.resources.dashboard_profile
import evoshift.composeapp.generated.resources.dashboard_revenue_vs_labor
import evoshift.composeapp.generated.resources.view_details
import org.jetbrains.compose.resources.pluralStringResource
import org.jetbrains.compose.resources.stringResource
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import com.evoapps.evoshift.widgets.MessageEffect

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun OwnerDashboardScreen(
    viewModel: OwnerDashboardViewModel,
    onNavigateToProfile: () -> Unit,
    onNavigateToFinancials: () -> Unit,
    onNavigateToTeam: () -> Unit,
    /** A person in "Today at work": that day of the roster. */
    onOpenAtWork: (AtWorkEntry) -> Unit = {},
    /** SH-54: the staffing hints card: the roster (builder) of its month. */
    onOpenRoster: (rosterId: String) -> Unit = {},
    /** SH-121: under a person in "Today at work" (their checklists today). */
    atWorkExtra: @Composable (AtWorkEntry) -> Unit = {},
    /** SH-134: the "to review" list above Today at work (shows nothing when there is nothing). */
    clockReview: @Composable () -> Unit = {},
    /**
     * SH-170: "Do zrobienia" at the top (it took over SH-164's inbox card); [showClockReview]
     * brings today's clock-in review list into view.
     */
    todo: @Composable (showClockReview: () -> Unit) -> Unit = {},
    /** SH-219: a new owner's start path, first roster in ten minutes (shows nothing once hidden or for an established workplace). */
    firstSteps: @Composable () -> Unit = {},
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    // SH-170: the to-do's "Sprawdź" scrolls to the clock-in review list above Today at work.
    val reviewRequester = remember { BringIntoViewRequester() }
    val scope = rememberCoroutineScope()
    val showClockReview: () -> Unit = { scope.launch { reviewRequester.bringIntoView() } }

    // SH-188: the takings' confirmation and failures that are not the first load's.
    val snackbarHostState = remember { SnackbarHostState() }
    MessageEffect(state.notice, snackbarHostState, onShown = viewModel::noticeShown)
    MessageEffect(state.error?.takeIf { state.loaded }, snackbarHostState, onShown = viewModel::clearError)
    Scaffold(
        containerColor = Cream,
        snackbarHost = { SnackbarHost(snackbarHostState) },
        topBar = {
            // SH-89: the shared bar: the workplace and the month of the figures. No title: the
            // bottom bar already says Home.
            EvoTopBar(
                showWorkplace = true,
                showMonth = true,
                actions = listOf(
                    helpAction(HelpPage.DAILY_RESULTS),
                    notificationsAction(),
                    TopBarAction(stringResource(Res.string.dashboard_profile), Icons.Default.Person, onNavigateToProfile, collapsible = false)
                )
            )
        },
    ) { padding ->
        // SH-130: the columns below scroll across the whole screen and centre their content.
        val maxWidth = LocalWindowWidthClass.current.wideContentMaxWidth
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
        ) {
            // SH-188: the first load failed: Try again instead of an empty dashboard.
            val loadError = state.loadError
            if (loadError != null && !state.loaded) {
                com.evoapps.evoshift.widgets.ErrorState(loadError, onRetry = viewModel::retry)
                return@Box
            }
            // Money only for those who may read it; the team's day for everyone here.
            val money = state.capabilities.shows(Gate.MONEY)
            // SH-247: before the first load the owner's dashboard is laid out as with the money (an
            // owner's dashboard is the one with it), its cards as placeholders.
            val loading = !state.loaded && state.capabilities.isEmpty()
            val moneyLaidOut = money || loading
            // SH-68: yesterday's or today's takings are missing: asked first, with the input.
            val missing = state.missingResults.firstOrNull()
            val fillDay: (@Composable () -> Unit)? = if (money && missing != null && state.capabilities.shows(Gate.MONEY_EDITING)) {
                {
                    FillDayResultCard(
                        record = missing,
                        isToday = missing.date == state.today,
                        currency = state.currency,
                        error = state.dailyResultError?.asString(),
                        onSave = { amount -> viewModel.onSubmitDailyResult(missing.date, amount) }
                    )
                }
            } else null
            val labour: @Composable () -> Unit = {
                if (moneyLaidOut) LoadingSwap(known = state.loaded, placeholder = { FigurePlaceholder() }, spacing = 8.dp) {
                    if (money) {
                        LaborCostCard(
                            percentage = state.laborCostPercentage,
                            base = state.laborBase,
                            trend = state.laborCostTrend,
                            onClick = onNavigateToFinancials,
                            modifier = Modifier.hoverLift(),
                            // SH-152: tap the % to see the month's labour cost and income it comes from.
                            explain = if (state.labourFromDays) ({ MonthExplanations.labourPercentOfDays(state.dailyTrend) }) else null,
                            currency = state.currency,
                            names = state.names,
                            // SH-191: the month's SPMH beside the labour %.
                            spmh = state.spmh,
                            spmhExplain = state.spmh?.let { { SpmhExplanations.days(Side.FORECAST, state.dailyTrend) } }
                        )
                        // SH-147: the labour % leaves out people working without pay terms.
                        state.statsRosterId?.let { MissingPayBanner(MissingPayScope(it)) }
                    }
                }
            }
            // SH-54: the days still to come with too few or too many staff for their sales.
            val staffing = state.staffing
            val staffingHints: (@Composable () -> Unit)? = if (money && staffing != null) {
                { StaffingHintsCard(staffing, onClick = { onOpenRoster(staffing.rosterId) }, modifier = Modifier.hoverLift()) }
            } else null

            val revenueVsLabor: @Composable () -> Unit = {
                LoadingSwap(known = state.loaded, placeholder = { SkeletonCard(lines = 3) }) {
                RevenueVsLaborCard(
                    month = state.statsMonth,
                    revenue = state.revenue,
                    laborCost = state.laborCost,
                    currency = state.currency,
                    onViewDetails = onNavigateToFinancials,
                    modifier = Modifier.hoverLift(),
                    // SH-225: the sales against last week and last year.
                    comparison = state.salesComparison
                )
                }
            }
            // SH-131: the month across the owner's workplaces, shared costs counted once.
            val businessMonth = state.business?.takeIf { money && it.hasFigures }
            val business: (@Composable () -> Unit)? = businessMonth?.let { b -> { BusinessMonthCard(b, state.currency) } }
            val teamSchedule: @Composable () -> Unit = {
                LoadingSwap(known = state.loaded, placeholder = { TeamSchedulePlaceholder() }) {
                    TeamScheduleCard(
                        activeEmployees = state.activeEmployees,
                        upcomingEmployees = state.upcomingEmployees,
                        completedEmployees = state.completedEmployees,
                        upcomingDate = state.upcomingDate,
                        onViewDetails = onNavigateToTeam.takeIf { state.capabilities.shows(Gate.TEAM) },
                        modifier = Modifier.hoverLift()
                    )
                }
            }

            // SH-226: the forecast for the coming days, where the week is planned (weather on only).
            val weather = upcomingWeatherSlot(state.weather, dashboardLoaded = state.loaded)

            // SH-47: medical exams and OHS training to renew.
            val staffChecks: (@Composable () -> Unit)? = if (state.capabilities.shows(Gate.TEAM) && state.staffAlerts.total > 0) {
                { StaffChecksCard(state.staffAlerts, onClick = onNavigateToTeam, modifier = Modifier.hoverLift()) }
            } else null

            // SH-219 / SH-170: the start path and "Do zrobienia" come first (requests, takings, pay, rosters).
            val inbox: (@Composable () -> Unit)? = {
                Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                    firstSteps()
                    todo(showClockReview)
                }
            }

            // Today's staff with their clock-in and clock-out (SH-72).
            val today: (@Composable () -> Unit)? = if (state.capabilities.shows(Gate.TODAY_AT_WORK) || loading) {
                {
                    Box(Modifier.bringIntoViewRequester(reviewRequester)) { clockReview() }
                    LoadingSwap(known = state.loaded, placeholder = { TodayAtWorkPlaceholder() }) {
                        TodayAtWorkCard(entries = state.todayAtWork, onOpen = onOpenAtWork, rowExtra = atWorkExtra)
                    }
                }
            } else null
            // The month day by day, then the last months (SH-40).
            val dailyChart: (@Composable () -> Unit)? = if (moneyLaidOut) {
                {
                    LoadingSwap(known = state.loaded, placeholder = { ChartPlaceholder(plotHeight = 200.dp) }) {
                        RevenueLaborChartCard(state.dailyTrend, currency = state.currency, labourTargetPercent = state.labourTargetPercent)
                    }
                }
            } else null
            val monthsChart: (@Composable () -> Unit)? = if (money) {
                { LaborTrendChartCard(state.monthTrend, currency = state.currency, labourTargetPercent = state.labourTargetPercent) }
            } else null
            val todayAndCharts: @Composable () -> Unit = {
                today?.invoke()
                dailyChart?.invoke()
                monthsChart?.invoke()
            }

            // SH-102: on a foldable the figures and charts sit above the hinge (left on a flat,
            // nearly square display); what asks for input or action below it: the day's takings
            // to type in, the staffing hints and the staff checks. Nothing to act on: one pane.
            val actions = listOfNotNull(inbox, fillDay, staffingHints, staffChecks)
            PostureAwareScaffold(
                controls = if (actions.isEmpty()) null else {
                    {
                        Column(
                            modifier = Modifier.fillMaxSize().verticalScroll(rememberScrollState()).contentWidth(maxWidth).padding(16.dp),
                            verticalArrangement = Arrangement.spacedBy(16.dp)
                        ) {
                            actions.forEach { it() }
                        }
                    }
                },
                content = {
                    Column(
                        modifier = Modifier.fillMaxSize().verticalScroll(rememberScrollState()).contentWidth(maxWidth).padding(horizontal = 16.dp),
                        verticalArrangement = Arrangement.spacedBy(16.dp)
                    ) {
                        Spacer(modifier = Modifier.height(8.dp))
                        labour()
                        if (moneyLaidOut) revenueVsLabor()
                        business?.invoke()
                        teamSchedule()
                        weather?.invoke()
                        todayAndCharts()
                        Spacer(modifier = Modifier.height(16.dp))
                    }
                },
                normal = {
                    Column(
                        modifier = Modifier
                            .fillMaxSize()
                            .verticalScroll(rememberScrollState())
                            .contentWidth(maxWidth)
                            .padding(horizontal = 16.dp),
                        verticalArrangement = Arrangement.spacedBy(16.dp)
                    ) {
                        Spacer(modifier = Modifier.height(8.dp))

                        val widthClass = LocalWindowWidthClass.current
                        if (widthClass.isCompact) {
                            inbox?.invoke()
                            fillDay?.invoke()
                            labour()
                            staffingHints?.invoke()
                            staffChecks?.invoke()
                            ResponsiveColumns(sections = if (moneyLaidOut) listOf(revenueVsLabor, teamSchedule) else listOf(teamSchedule), maxColumns = 2)
                            weather?.invoke()
                            business?.invoke()
                            todayAndCharts()
                        } else {
                            // SH-105: wide windows read across: what needs doing and today on the
                            // left, the month's money and its charts on the right; laptop-wide ones
                            // give the figures a column of their own between them.
                            val todo = listOfNotNull(inbox, fillDay, staffingHints, staffChecks, today)
                            val figures = if (moneyLaidOut) listOfNotNull(labour, revenueVsLabor, business) else emptyList()
                            val charts = listOfNotNull(dailyChart, monthsChart)
                            val columns = when {
                                !moneyLaidOut -> listOf(listOfNotNull(inbox, fillDay, staffChecks, today), listOfNotNull(teamSchedule, weather))
                                widthClass.isLarge -> listOf(todo, figures + teamSchedule + listOfNotNull(weather), charts)
                                else -> listOf(todo + teamSchedule + listOfNotNull(weather), figures + charts)
                            }
                            DashboardColumns(columns)
                        }

                        Spacer(modifier = Modifier.height(48.dp))
                    }
                }
            )

            // SH-247: no spinner over the dashboard: each card shows its placeholder until it is known.
        }
    }
}

/**
 * SH-68: "Fill in the day's result?" for a day without takings: the day, its target and the
 * takings (net) typed right here. Keyed by the day, so the next missing day starts empty.
 */
@Composable
fun FillDayResultCard(
    record: DailyRecord,
    isToday: Boolean,
    currency: String,
    error: String?,
    onSave: (Double) -> Unit,
    modifier: Modifier = Modifier
) {
    key(record.date) {
        var amount by remember { mutableStateOf("") }
        val parsed = parseDecimal(amount)
        val invalid = amount.isNotBlank() && (parsed == null || parsed < 0)
        val date = LocalDate.parse(record.date)
        val day = "${date.day} (${dayShort(date.dayOfWeek)})"
        RegularCard(modifier = modifier.fillMaxWidth()) {
            Column(modifier = Modifier.padding(24.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                Text(
                    stringResource(Res.string.dashboard_fill_result_title),
                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                    color = DeepNavy
                )
                Text(
                    stringResource(if (isToday) Res.string.dashboard_fill_result_today else Res.string.dashboard_fill_result_yesterday, day),
                    style = MaterialTheme.typography.bodyLarge,
                    color = DeepNavy
                )
                Text(
                    stringResource(Res.string.dashboard_fill_result_target, formatMoney(record.revenue.planNetto, currency)),
                    style = MaterialTheme.typography.bodyMedium,
                    color = DeepNavy.copy(alpha = 0.7f)
                )
                EvoTextField(
                    value = amount,
                    onValueChange = { amount = it },
                    label = stringResource(Res.string.daily_records_actual_net),
                    keyboardType = KeyboardType.Decimal,
                    imeAction = ImeAction.Done,
                    error = stringResource(Res.string.number_invalid).takeIf { invalid } ?: error,
                    suffix = currency,
                    onLight = true
                )
                GoldButton(
                    text = stringResource(Res.string.save),
                    onClick = { parsed?.let(onSave) },
                    enabled = parsed != null && !invalid,
                    modifier = Modifier.fillMaxWidth()
                )
            }
        }
    }
}

@Composable
fun LaborCostCard(
    percentage: Double,
    trend: Int,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    base: LabourBase = LabourBase.SALES,
    /** SH-152: how the % was worked out (tap the figure); null without it. */
    explain: (() -> Calculation?)? = null,
    currency: String = "",
    names: Map<String, String> = emptyMap(),
    /** SH-191: the month's SPMH (sales per man-hour) and how it was worked out; null: not shown. */
    spmh: Double? = null,
    spmhExplain: (() -> Calculation?)? = null
) {
    StandoutCard(
        modifier = modifier.fillMaxWidth(),
        onClick = onClick
    ) {
        Column(modifier = Modifier.padding(24.dp)) {
            Text(
                // SH-95: "of income" with a commission, "of sales" without one.
                text = stringResource(labourCardTitleRes(base)),
                style = MaterialTheme.typography.titleMedium.copy(
                    fontWeight = FontWeight.Bold
                ),
                color = LocalOnColours.current.accent
            )
            Spacer(modifier = Modifier.height(8.dp))

            Row(
                verticalAlignment = Alignment.CenterVertically
            ) {
                CompositionLocalProvider(LocalExplainNames provides names) {
                    ExplainableAmount(
                        text = formatPercent(percentage),
                        explain = explain,
                        currency = currency,
                        style = MaterialTheme.typography.displayLarge.copy(
                            fontWeight = FontWeight.Bold
                        ),
                        color = LocalOnColours.current.onSurface,
                        animated = true
                    )
                }
                Spacer(modifier = Modifier.weight(1f))
                if (trend != 0) {
                    Icon(
                        imageVector = if (trend < 0) Icons.AutoMirrored.Filled.TrendingDown else Icons.AutoMirrored.Filled.TrendingUp,
                        contentDescription = null,
                        modifier = Modifier.height(48.dp).width(48.dp),
                        tint = if (trend < 0) LocalOnColours.current.success else LocalOnColours.current.error
                    )
                }
            }
            if (spmh != null) {
                Spacer(modifier = Modifier.height(8.dp))
                Row(verticalAlignment = Alignment.Bottom, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    Text(
                        stringResource(Res.string.spmh),
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                        color = LocalOnColours.current.accent
                    )
                    ExplainableAmount(
                        text = formatSpmhOrDash(spmh, currency),
                        explain = spmhExplain,
                        currency = currency,
                        style = MaterialTheme.typography.headlineSmall.copy(fontWeight = FontWeight.Bold),
                        color = LocalOnColours.current.onSurface,
                        animated = true
                    )
                }
            }
        }
    }
}

@Composable
fun RevenueVsLaborCard(
    month: Int?,
    revenue: Double?,
    laborCost: Double?,
    currency: String,
    onViewDetails: () -> Unit,
    modifier: Modifier = Modifier,
    /** SH-225: the chips "vs zeszły tydzień" (week to date) and "vs rok temu" (month to date); null: none. */
    comparison: com.evoapps.evoshift.domain.usecase.finance.DashboardSalesComparison? = null
) {
    RegularCard(
        modifier = modifier.fillMaxWidth(),
        onClick = onViewDetails
    ) {
        Column(modifier = Modifier.padding(24.dp)) {
            Text(
                stringResource(
                    Res.string.dashboard_revenue_vs_labor,
                    inMonth(month ?: currentMonthNumber())
                ),
                style = MaterialTheme.typography.titleMedium.copy(
                    fontWeight = FontWeight.Bold
                ),
                color = DeepNavy.copy(alpha = 0.7f)
            )
            Spacer(modifier = Modifier.height(16.dp))

            if (revenue == null && laborCost == null) {
                 Text(
                     stringResource(Res.string.dashboard_no_active_data),
                     style = MaterialTheme.typography.bodyMedium,
                     color = DeepNavy
                 )
            } else {
                listOf(
                    stringResource(Res.string.revenue) to revenue,
                    stringResource(Res.string.financials_labor_costs) to laborCost
                ).forEach { (label, amount) ->
                    AnimatedAmountText(
                        "$label: ${formatMoney(amount ?: 0.0, currency)}",
                        style = MaterialTheme.typography.bodyLarge,
                        color = DeepNavy,
                        modifier = Modifier.padding(vertical = 4.dp)
                    )
                }
            }
            if (comparison != null) {
                SalesComparisonChips(comparison, Modifier.padding(top = 8.dp))
            }

            TextButton(
                onClick = onViewDetails,
                modifier = Modifier.align(Alignment.Start).padding(top = 8.dp)
            ) {
                Text(
                    stringResource(Res.string.view_details),
                    style = MaterialTheme.typography.labelLarge.copy(fontWeight = FontWeight.Bold),
                    color = DeepNavy
                )
            }
        }
    }
}

/** "Od dziś: za mało osób w 2 dniach, za dużo osób w 1 dniu." Only the counts above zero are named. */
@Composable
internal fun staffingSummary(tooFew: Int, tooMany: Int): String {
    val few = if (tooFew > 0) pluralStringResource(Res.plurals.staffing_too_few_days, tooFew, tooFew) else null
    val many = if (tooMany > 0) pluralStringResource(Res.plurals.staffing_too_many_days, tooMany, tooMany) else null
    return when {
        few != null && many != null -> stringResource(Res.string.staffing_card_summary_both, few, many)
        few != null || many != null -> stringResource(Res.string.staffing_card_summary, few ?: many!!)
        else -> stringResource(Res.string.staffing_card_all_right)
    }
}

/**
 * SH-54: the month's days from today on outside the labour target (rules: planned labour % of the
 * expected sales), the first few by name with their chip; a tap opens the roster to change them.
 */
@Composable
fun StaffingHintsCard(staffing: StaffingActions, onClick: () -> Unit, modifier: Modifier = Modifier) {
    RegularCard(modifier = modifier.fillMaxWidth(), onClick = onClick) {
        Row(modifier = Modifier.padding(16.dp).fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
            Icon(Icons.Default.Groups, null, tint = if (staffing.days.isEmpty()) staffingColor(StaffingVerdict.JUST_RIGHT) else DeepNavy.copy(alpha = 0.7f))
            Spacer(Modifier.width(16.dp))
            Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                Text(
                    stringResource(Res.string.staffing_card_title),
                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                    color = DeepNavy.copy(alpha = 0.7f)
                )
                Text(
                    if (staffing.days.isEmpty()) stringResource(Res.string.staffing_card_all_right)
                    else staffingSummary(staffing.tooFew, staffing.tooMany),
                    style = MaterialTheme.typography.bodyMedium,
                    color = DeepNavy
                )
                staffing.days.take(3).forEach { hint ->
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Text(
                            "${hint.date.day} (${dayShort(hint.date.dayOfWeek)})",
                            style = MaterialTheme.typography.bodySmall,
                            color = DeepNavy,
                            modifier = Modifier.width(72.dp)
                        )
                        StaffingChip(hint)
                    }
                }
            }
            Icon(Icons.AutoMirrored.Filled.ArrowForward, contentDescription = stringResource(Res.string.staffing_card_open), tint = DeepNavy.copy(alpha = 0.7f))
        }
    }
}

/** SH-225: the revenue card's chips: the week to date against last week, the month to date against last year. */
@OptIn(androidx.compose.foundation.layout.ExperimentalLayoutApi::class)
@Composable
internal fun SalesComparisonChips(comparison: com.evoapps.evoshift.domain.usecase.finance.DashboardSalesComparison, modifier: Modifier = Modifier) {
    androidx.compose.foundation.layout.FlowRow(
        modifier,
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalArrangement = Arrangement.spacedBy(6.dp)
    ) {
        val sales = com.evoapps.evoshift.domain.comparison.ComparisonMetric.NET_SALES
        com.evoapps.evoshift.ui.finance.ComparisonChip(com.evoapps.evoshift.domain.comparison.ComparisonMode.LAST_WEEK, comparison.weekToDate.change(sales))
        com.evoapps.evoshift.ui.finance.ComparisonChip(com.evoapps.evoshift.domain.comparison.ComparisonMode.LAST_YEAR_WEEKDAY, comparison.monthToDate.change(sales))
    }
}
